<script setup lang="ts">
import CarouselMobile from '../../../CarouselMobile/CarouselMobile.vue';
import IMG_MSG_HIDE from '../../assets/msg-hide.png';
import IMG_STEP_HIDE from '../../assets/step-hide.png';

interface Props {
  backgroundImage: string;
  productImage?: string;
  isMsgShow?: boolean;
}

withDefaults(defineProps<Props>(), {
  productImage: '',
  isMsgShow: true
});
</script>

<template>
<div class="hide">
  <CarouselMobile
    :mobileFrameImage="IMG_STEP_HIDE"
    :backgroundImage="backgroundImage"
    :productImage="productImage"
    :msgImage="IMG_MSG_HIDE"
    :isMsgShow="isMsgShow"
    :isShowHeaderInfo="true"
  />
</div>
</template>
